import { Stack } from "@mui/material";
import { CopyableTextField } from "@src/appV2/CopyableTextField/CopyableTextField";
import { getLocation } from "@src/appV2/redesign/utils/routes";

import { NavigationMenuItemDesktop } from "./MenuItem";
import { NavigationMenuSectionTitleDesktop } from "./MenuSectionTitle";

interface CurrentlyViewedSectionDesktopProps {
  admin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  currentName: string;
  currentUserId: string;
}

/**
 * Renders the "Currently Viewed" section: a clickable worker/workplace name link
 * followed by copyable Professional Name / ID fields.
 */
export function CurrentlyViewedSectionDesktop(props: CurrentlyViewedSectionDesktopProps) {
  const { admin, isWorker, isWorkplace, currentName, currentUserId } = props;

  // Only show for admin users that are currently posing as a workplace or worker
  if (!admin || (!isWorker && !isWorkplace)) {
    return null;
  }

  const profileRoute = isWorker ? getLocation("agentProfile") : getLocation("facilityProfile");

  return (
    <>
      <NavigationMenuSectionTitleDesktop>Currently Viewed</NavigationMenuSectionTitleDesktop>
      <NavigationMenuItemDesktop iconType="person-male" isSelected={false} routeTo={profileRoute}>
        {currentName}
      </NavigationMenuItemDesktop>
      <Stack gap={2} sx={{ paddingTop: 2 }}>
        <CopyableTextField
          label={isWorkplace ? "Workplace Name" : "Professional Name"}
          value={currentName}
        />
        <CopyableTextField
          label={isWorkplace ? "Workplace ID" : "Professional ID"}
          value={currentUserId}
        />
      </Stack>
    </>
  );
}
